<template lang="pug">
	.overlayer
		.overlayer-background(@click.stop="close()")
		.overlayer-wrapper
			.overlayer-close(@click.stop="close()")
			.overlayer-body
				div.overlayer-inner(v-html="insertDom")
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import store from './../store';

export default {
	name: 'Overlayer',
	methods: {
		close(){
			this.$parent.closeOverlayer();
			_.delay(()=> store.commit('setOverlayerDom', ''), 800);
		}
	},
	computed: {
    insertDom() {
      return store.state.overlayer;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Overlayer.vue